import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
import { DxBaseControlOptions } from "./dx-base-control-options";
let DxTextareaControlOptions = class DxTextareaControlOptions extends DxBaseControlOptions {
    get placeholder() {
        return this._placeholder;
    }
    set placeholder(value) {
        this._placeholder = value;
    }
    get isFocused() {
        return this._isFocused;
    }
    set isFocused(value) {
        this._isFocused = value;
    }
    get rows() {
        return this._rows;
    }
    set rows(value) {
        this._rows = value;
    }
    get cols() {
        return this._cols;
    }
    set cols(value) {
        this._cols = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "placeholder", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxTextareaControlOptions.prototype, "_placeholder", void 0);
tslib_1.__decorate([
    jsonMember({ name: "isFocused", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxTextareaControlOptions.prototype, "_isFocused", void 0);
tslib_1.__decorate([
    jsonMember({ name: "cols", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], DxTextareaControlOptions.prototype, "_cols", void 0);
tslib_1.__decorate([
    jsonMember({ name: "rows", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], DxTextareaControlOptions.prototype, "_rows", void 0);
DxTextareaControlOptions = tslib_1.__decorate([
    jsonObject
], DxTextareaControlOptions);
export { DxTextareaControlOptions };
